<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-20 10:17:18
 * @LastEditors: Betway
 * @LastEditTime: 2026-05-26 11:50:50
 * @FilePath: \web_admin\src\LAYOUT\main-content\top-aside\avatar.vue
-->
<template>
  <div>
    <v-menu
      offset-y
      transition="slide-x-reverse-transition"
      :close-on-content-click="false"
      nudge-bottom="12"
    >
      <template v-slot:activator="{ on }">
        <v-avatar class="avatar" size="32">
          <v-img
            :src="avatar"
            v-if="avatarStatus"
            v-on="on"
            width="32"
            class="grey lighten-2"
            style="border-radius: 50%; cursor: pointer"
            height="32"
          >
            <template v-slot:placeholder>
              <v-progress-circular
                :size="32"
                :width="2"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </template>
          </v-img>
          <v-img
            src="~@/assets/img/default_avator.png"
            v-else
            v-on="on"
            width="32"
            class="grey lighten-2"
            style="border-radius: 50%; cursor: pointer"
            height="32"
          >
            <template v-slot:placeholder>
              <v-progress-circular
                :size="32"
                :width="2"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </template>
          </v-img>
          <!-- <v-btn fab
                 v-on="on"
                 v-else
                 x-small
                 style="border:1px solid rgba(0,0,0,0.1);"
                 elevation="0"
                 :color="colorArr[randomcolor]">
            <span style="color:#ffffff;font-size:18px;">
              {{ $store.state.userData.user_account.substr(0, 1).toUpperCase() }}
            </span>
          </v-btn> -->
        </v-avatar>
      </template>
      <v-card class="logBox">
        <div class="logTop" :style="{ backgroundColor: '#739ce8' }"></div>
        <div class="logFooter">
          <!-- :color="avatarStatus ? '' : colorArr[randomcolor]" -->
          <v-avatar
            class="avatar"
            style="position: absolute; top: 20px; border: 1px solid rgba(0, 0, 0, 0.1)"
            size="96"
          >
            <v-progress-circular
              :size="96"
              v-if="uploading"
              :width="7"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <div v-else>
              <v-img :src="avatar" width="96" height="96" v-if="avatarStatus">
                <template v-slot:placeholder>
                  <v-progress-circular
                    :size="96"
                    :width="7"
                    color="primary"
                    indeterminate
                  ></v-progress-circular>
                </template>
              </v-img>
              <v-img src="~@/assets/img/default_avator.png" v-else width="96" height="96">
                <template v-slot:placeholder>
                  <v-progress-circular
                    :size="96"
                    :width="7"
                    color="primary"
                    indeterminate
                  ></v-progress-circular>
                </template>
              </v-img>
              <!-- <span v-else
                    style="font-size:56px;text-transform:uppercase;color:#ffffff">
                {{ $store.state.userData.user_account.substr(0, 1) }}
              </span> -->
            </div>
            <div :class="uploading ? '' : 'overlay'" style="display: none">
              <v-overlay absolute>
                <div class="d-flex">
                  <div
                    style="
                      width: 22px;
                      height: 22px;
                      position: relative;
                      overflow: hidden;
                    "
                  >
                    <mrc_ess_fileInput
                      :accept="accept"
                      style="width: 22px; height: 22px; overflow: hidden"
                      :uploadFileType="uploadFileType"
                      @changeimgSrc="changeimgSrc"
                    ></mrc_ess_fileInput>
                    <v-icon
                      class="material-icons"
                      style="color: #ffffff; cursor: pointer"
                    >
                      edit
                    </v-icon>
                  </div>
                  <div v-if="avatarStatus" class="ml-4">
                    <v-icon
                      class="material-icons"
                      @click="deleteavatar"
                      style="color: #ffffff; cursor: pointer"
                    >
                      delete
                    </v-icon>
                  </div>
                </div>
              </v-overlay>
            </div>
          </v-avatar>

          <div class="title text-truncate" style="margin-top: 75px">
            {{ $store.state.userData.user_account || "StaffName" }}
          </div>
          <div class="grey--text text-truncate" style="font-size: 12px">
            <!-- {{ $store.state.userData.user_id  }} -->
          </div>
          <div class="grey--text text-truncate" style="font-size: 12px">
            <!-- {{ $store.state.userData.job  }} -->
          </div>
          <!-- <v-btn color="primary"
                 rounded
                 class="mt-2 text-capitalize"
                 :elevation="0"
                 min-width="182"
                 min-height="36"
                 @click="changePassword"
                 dark>
            <span>{{ $t("label_ChangePassword") }}</span>
          </v-btn> -->
          <v-spacer
            style="margin-top: 32px; height: 1px; width: 95%; background-color: #e8e8e8"
          ></v-spacer>
          <v-btn
            text
            rounded
            :loading="kc_loading"
            :disabled="kc_loading"
            class="logout text-capitalize my-2"
            :style="{ color: $vuetify.theme.defaults.light.primary }"
            @click="login_out"
          >
            {{ $t("label_logout") }}
          </v-btn>
        </div>
      </v-card>
      <!-- </v-list-item> -->
      <!-- </v-list> -->
    </v-menu>

    <mrc_ess_myDialog
      v-model="changePasswordDialog"
      :title="$t('label_To_reset_your_password')"
      width="680"
      @success="savePassword"
      :loading="loading"
      @cancel="cancel"
    >
      <mrc_ess_input
        :placeholder="$t('label_OriginalPassword') + '*'"
        :label="$t('label_OriginalPassword') + '*'"
        background-color="#fff"
        style="margin-top: 34px"
        @input="$v.params.old_pwd.$touch()"
        @blur="$v.params.old_pwd.$touch()"
        v-model.trim="params.old_pwd"
        :type="type"
        :append-icon="icon"
        @click:append="showPassword"
        :error-messages="
          $errors(
            'params',
            'old_pwd',
            requiredRule.concat([{ rule: 'isChina', msg: '不能输入中文' }])
          )
        "
      ></mrc_ess_input>
      <mrc_ess_input
        :label="$t('label_newpassword') + '*'"
        :placeholder="$t('label_newpassword') + '*'"
        background-color="#fff"
        @input="$v.params.user_pwd.$touch()"
        @blur="$v.params.user_pwd.$touch()"
        v-model.trim="params.user_pwd"
        :type="type"
        :append-icon="icon"
        @click:append="showPassword"
        :error-messages="
          $errors(
            'params',
            'user_pwd',
            requiredRule.concat(
              { rule: 'isChina', msg: '不能输入中文' },
              { rule: 'passwordStrengthRegxRule', msg: regxMsg }
            )
          )
        "
      ></mrc_ess_input>
      <mrc_ess_input
        :placeholder="$t('label_Retypepassword') + '*'"
        :label="$t('label_Retypepassword') + '*'"
        background-color="#fff"
        @input="$v.params.RetypePwd.$touch()"
        @blur="$v.params.RetypePwd.$touch()"
        :append-icon="icon"
        :type="type"
        @click:append="showPassword"
        v-model.trim="params.RetypePwd"
        :error-messages="
          $errors(
            'params',
            'RetypePwd',
            requiredRule.concat([
              { rule: 'sameAsNewPassword', msg: '两次密码输入不一致' },
            ])
          )
        "
      ></mrc_ess_input>
    </mrc_ess_myDialog>
  </div>
</template>

<script>
import { findSrc } from "@/service/api/upload.js";
import { required, minLength } from "vuelidate/lib/validators";
import {
  updatePassword,
  passwordStrength,
  updateAvatar,
} from "@/service/api/forgot-password";
import userImg from "@/assets/img/default_avator.png";
export default {
  components: {},
  props: {
    kc_loading: { default: false },
  },
  data() {
    return {
      userImg: userImg,
      colorArr: [
        "#637A88",
        "#3F9B30",
        "#289DAA",
        "#66B4E7",
        "#4354B4",
        "#7C81FC",
        "rgb(147, 76, 14)",
        "#AA3E90",
        "#FC8282",
        "#AA3E3E",
        "#ED7217",
        "#DBB016",
      ],
      uploading: false, //图片上传的加载状态
      randomcolor: null,
      overlay: true,
      accept: "image/*",
      uploadFileType: /\.(png|jpg|gif|jpeg|webp)$/,
      loading: false,
      changePasswordDialog: false,
      params: {
        old_pwd: "", // 旧密码
        user_pwd: "", // 新密码
        RetypePwd: "", // 再次输入新密码
      },
      icon: "mdi-eye-off",
      type: "password",
      is_showPassword: false,
      regxRule: null,
      regxMsg: "",
      avatar: "",
    };
  },
  validations: {
    params: {
      old_pwd: {
        // illegal (val) {
        //   return this.illegal(val)
        // },
        required,
        isChina(val) {
          return this.isChina(val);
        },
      },
      user_pwd: {
        required,
        isChina(val) {
          return this.isChina(val);
        },
        passwordStrengthRegxRule(val) {
          return new RegExp(this.regxRule).test(val);
        },
      },
      RetypePwd: {
        required,
        sameAsNewPassword(val) {
          return val && val == this.params.user_pwd;
        },
      },
    },
  },
  computed: {
    avatarStatus() {
      if (
        this.$store.state.userData.thumbnail_img &&
        this.$store.state.userData.thumbnail_img != ""
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.randomcolor = Math.round(Math.random() * (this.colorArr.length - 1));
  },
  watch: {},
  mounted() {
    if (this.$store.state.userData.thumbnail_img) {
      this.getpath(this.$store.state.userData.thumbnail_img);
    }
  },
  beforeRouteUpdate() {},
  methods: {
    deleteavatar() {
      //删除头像
      this.uploading = true;
      updateAvatar({
        thumbnail_img: "",
        del: this.$store.state.userData.thumbnail_img || "",
      })
        .then((res) => {
          if (res.code == 200) {
            let userData = this.$store.state.userData;
            this.$store.commit("set_userData", {
              ...userData,
              thumbnail_img: "",
            });
            this.avatar = "";
            this.uploading = false;
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            });
          }
        })
        .catch((err) => {
          this.uploading = false;
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    changeimgSrc(val) {
      //上传头像
      // console.log(val);
      if (val == "") return;
      this.uploading = true;
      this.$uploadFiles(val, {
        module_uuid: "staff",
        function_uuid: this.$store.state.menuFunctionUuid,
        attachment_data_field: "thumbnail_img",
        org_level_uuid: this.$store.state.currentCompany,
      })
        .then(async (res) => {
          let url = "";
          if (typeof res == "object" && res != undefined && res.code == 200) {
            url = res.upload_url;
            await updateAvatar({
              thumbnail_img: res.uuid,
              del: this.$store.state.userData.thumbnail_img || "",
            }).then((resp) => {
              if (resp.code == 200) {
                this.getpath(res.uuid, false); //请求新的url路径
                this.$Message({
                  text: this.$t("message_The_upload_was_successful"),
                });
                let userData = this.$store.state.userData;
                this.$store.commit("set_userData", {
                  ...userData,
                  thumbnail_img: res.uuid,
                });
              } else {
                this.uploading = false;
              }
            });
          }
        })
        .catch((err) => {
          this.uploading = false;
          this.$Message({
            text: this.$t("error_UPLOAD_FAIL"),
            color: "rgba(0,0,0,0.78)",
          });
        });
    },
    async getpath(val, status) {
      //获取图片地址
      if (!val) return (this.avatar = "");
      findSrc({ uuid: val }).then((res) => {
        if (res.data.files.length > 0) {
          this.avatar = res.data.files[0].path;
          if (!status) this.uploading = false;
        } else {
          this.avatar = "";
          if (!status) this.uploading = false;
        }
      });
    },
    login_out() {
      this.$emit("login_out");
    },
    async changePassword() {
      this.$v.params.$reset();
      const res = await this.getPasswordStrength();

      this.changePasswordDialog = true;
    },
    async getPasswordStrength() {
      await this.$store.dispatch("setPubk");
      const res = await passwordStrength({
        // user_account: this.$store.state.userData.user_account,
        user_account: this.$encrypt({
          msg: this.$store.state.userData.user_account,
          key: this.$store.getters.pubk,
        }),
      });
      if (res.code == 200) {
        this.regxMsg = res.data.ceckmean;
        this.regxRule = res.data.cecknum;
      }
    },
    async savePassword() {
      this.$v.params.$touch();
      if (this.$v.params.$error) return;
      this.loading = true;
      const res = await updatePassword({
        // old_pwd: this.params.old_pwd,
        old_pwd: this.$encrypt({
          msg: this.params.old_pwd,
          key: this.$store.getters.pubk,
        }),
        // user_account:  this.$encrypt({
        //   msg: this.$store.state.userData.user_account,
        //   key: this.$store.getters.pubk,
        // }),
        user_pwd: this.$encrypt({
          msg: this.params.user_pwd,
          key: this.$store.getters.pubk,
        }),
      });
      if (res.code == 200) {
        // this.$Message({
        //   text: this.$t('message_The_modification_was_successful'),
        // })
        this.changePasswordDialog = false;
        this.$router.push({
          path: "/login",
        });
        this.$Message({
          text: "密码修改成功，需要您重新登录",
        });
      }
      this.loading = false;
    },
    cancel() {},
    showPassword() {
      this.is_showPassword = !this.is_showPassword;
      if (this.is_showPassword) {
        this.icon = "mdi-eye";
        this.type = "text";
      } else {
        this.icon = "mdi-eye-off";
        this.type = "password";
      }
    },
  },
};
</script>

<style scoped>
.v-avatar:hover .overlay {
  display: block !important;
}

.v-menu__content {
  border-radius: 8px !important;
}

.logBox {
  width: 314px;
  /* height: 333px; */
  /* background-color: #ffffff; */
  /* border-radius: 10px; */
  position: relative;
}

.logTop {
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
  height: 72px;
}

.logFooter {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.editimg {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  justify-content: center;
  align-content: center;
  opacity: 0.5;
  background-color: rgba(0, 0, 0, 0.4);
}

.userhead {
  display: inline-block;
  line-height: 96px;
  text-align: center;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  /* background-color: #efefef; */
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 24px;
}

/* .userhead:hover {
  cursor: pointer;
} */
.logout {
  color: #0f46c1;
  font-family: var(--body-font-family);
  font-weight: medium;
  font-size: 14px;
  line-height: 1.25;
  letter-spacing: 1.25px;
  text-align: center;
}
</style>
